import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import {
  FiArrowLeft,
  FiChevronRight,
  FiCheckSquare,
  FiUser,
  FiUsers,
  FiCalendar,
  FiClipboard,
  FiMapPin,
  FiCheckCircle,
} from 'react-icons/fi';
import DashboardLayout from '../../components/layout/DashboardLayout';
import SectionCard from '../../components/ui/SectionCard';
import ListItem from '../../components/ui/ListItem';
import { VISIT_FORMS } from '../../models/formTypes';
import { getHouses } from '../../services/houseService';

const FORM_ICONS = {
  'vote-intention': FiCheckSquare,
  'citizen-data': FiUser,
  'community-participation': FiUsers,
  'follow-up-closing': FiCalendar,
};

/**
 * Vista de selección de formularios de la conversación con el ciudadano
 * (formularios 4 al 7). Se muestra después de registrar una visita con
 * resultado "Conversación realizada", permitiendo al operativo elegir
 * libremente a qué formulario entrar para capturar datos.
 */
export default function HouseFormsListView() {
  const { houseId } = useParams();
  const [house, setHouse] = useState(null);

  useEffect(() => {
    let active = true;
    getHouses()
      .then((houses) => {
        if (!active) return;
        const found = houses?.find((h) => String(h.id) === String(houseId));
        if (found) setHouse(found);
      })
      .catch(() => {});

    return () => {
      active = false;
    };
  }, [houseId]);

  const houseAddress = house
    ? `${house.address.street} ${house.address.exteriorNumber}`.trim() +
      (house.address.neighborhood ? `, ${house.address.neighborhood}` : '')
    : null;

  return (
    <DashboardLayout
      title="Formularios de la visita"
      subtitle={houseAddress || 'Selecciona un formulario para capturar'}
    >
      {houseAddress && (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            fontSize: '0.88rem',
            color: 'var(--pulso-text-muted)',
            padding: '8px 12px',
            background: 'var(--pulso-surface)',
            borderRadius: 'var(--pulso-radius-sm)',
            border: '1px solid var(--pulso-border)',
          }}
        >
          <FiMapPin style={{ color: 'var(--pulso-primary)', flexShrink: 0 }} />
          <span>
            Vivienda: <strong>{houseAddress}</strong>
          </span>
        </div>
      )}

      <SectionCard title="Formularios disponibles">
        {VISIT_FORMS.map((form) => {
          const Icon = FORM_ICONS[form.slug] || FiClipboard;
          return (
            <ListItem
              key={form.slug}
              as={Link}
              to={`/data-entry/houses/${houseId}/forms/${form.slug}`}
              icon={<Icon />}
              title={form.label}
              meta={form.description}
              right={<FiChevronRight />}
            />
          );
        })}
      </SectionCard>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginTop: 4 }}>
        <Link to="/data-entry/houses" className="btn btn-primary btn-block">
          <FiCheckCircle /> Concluir visita
        </Link>
        <Link to={`/data-entry/houses/${houseId}/visit`} className="btn btn-outline btn-block">
          <FiArrowLeft /> Volver a resultado de visita
        </Link>
      </div>
    </DashboardLayout>
  );
}
